import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CloudinaryWidget from 'components/CloudinaryWidget';
import { default as MainHeader } from 'pages/home/Header';
import Switch from 'components/Switch';
import TextField from 'components/TextField';
import Select from 'components/Select';
import { updateSection } from 'actions/webPages';
import {
  Card,
  CardTitle,
  Row,
  AddSectionButton,
  AddSectionHeader,
  SectionNavbar,
  TwoBoxWrapper,
} from 'styles/pages/web-pages';

const Header = ({ data }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.auth?.profile?.token);
  const [bannerData, setBannerData] = useState(null);

  useEffect(() => {
    if (data && data?.find((d) => d?.name === 'Header')) {
      const d = data?.find((d) => d?.name === 'Header');
      setBannerData(() => d);
    }
  }, [data]);

  const { components, navVisibility, name } = bannerData || {};
  const { BackgroundColor = '', Buttons, Image = '' } = components || {};

  return (
    <Card>
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999999,
          }}></div>
        <MainHeader data={bannerData || {}} />
      </div>

      <SectionNavbar>
        <CardTitle style={{ border: 'none' }}>{name}</CardTitle>
        <Switch
          handleChange={(e) =>
            setBannerData({
              ...bannerData,
              navVisibility: e.target.checked,
            })
          }
          checked={navVisibility || false}
        />
      </SectionNavbar>

      <TwoBoxWrapper>
        <TextField
          label='Background Color'
          size='small'
          value={BackgroundColor}
          onChange={(v) =>
            setBannerData({
              ...bannerData,
              components: {
                ...bannerData.components,
                BackgroundColor: v,
              },
            })
          }
        />
        <CloudinaryWidget
          label='Logo'
          value={Image}
          setValue={(v) =>
            setBannerData({
              ...bannerData,
              components: {
                ...bannerData.components,
                Image: v,
              },
            })
          }
          folderPath={`Shirtly/Web_Pages/LandingPage/${name}`}
        />
      </TwoBoxWrapper>

      <CardTitle>Button Settings</CardTitle>
      {Buttons?.map((r, i) => (
        <Row key={`button${i}`}>
          <Switch
            handleChange={(e) =>
              setBannerData({
                ...bannerData,
                components: {
                  ...bannerData.components,
                  Buttons: bannerData.components.Buttons?.map((b, j) =>
                    i === j ? { ...b, Show: e.target.checked } : b
                  ),
                },
              })
            }
            checked={r?.Show}
          />

          <TextField
            label='Button Name'
            size='small'
            value={r?.ButtonName || ''}
            onChange={(v) =>
              setBannerData({
                ...bannerData,
                components: {
                  ...bannerData.components,
                  Buttons: bannerData.components.Buttons?.map((b, j) =>
                    i === j ? { ...b, ButtonName: v } : b
                  ),
                },
              })
            }
          />
          <Select
            label='Link To'
            value={{ value: r?.Modal }}
            labelKey='label'
            valueKey='value'
            options={[
              { label: 'SignIn', value: 'SignIn' },
              { label: 'SignUp', value: 'SignUp' },
            ]}
            onChange={(v) =>
              setBannerData({
                ...bannerData,
                components: {
                  ...bannerData.components,
                  Buttons: bannerData.components.Buttons?.map((b, j) =>
                    i === j ? { ...b, Modal: v } : b
                  ),
                },
              })
            }
          />
        </Row>
      ))}

      <AddSectionHeader>
        <AddSectionButton
          title='Update'
          onClick={async () => {
            const payload = {
              ...bannerData,
              page: 'LandingPage',
            };

            await dispatch(updateSection({ data: payload, token }));
          }}
        />
      </AddSectionHeader>
    </Card>
  );
};

export default Header;
